import { cn } from "../../lib/utils";
import {
  LayoutDashboard,
  Folder,
  Users,
  UserCircle,
  Shield,
  ScrollText,
  PanelLeftClose,
  PanelLeftOpen,
} from "lucide-react";
import { NavLink } from "react-router-dom";
import useAuthStore from "../../stores/useAuthStore";
import logoCarex from "../../assets/images/logo/logo-carex.svg";

const Sidebar = ({ isOpen = true, onToggle }) => {
  const { user } = useAuthStore();
  const navItems = [
    {
      label: "Tableau de bord",
      icon: LayoutDashboard,
      href: "/",
    },
    {
      label: "Dossiers",
      icon: Folder,
      href: "/dossiers",
    },
    {
      label: "Clients",
      icon: Users,
      href: "/clients",
    },
    {
      label: "Mon profil",
      icon: UserCircle,
      href: "/profil",
    },
  ];

  const adminItems = [
    {
      label: "Utilisateurs",
      icon: Shield,
      href: "/admin/utilisateurs",
    },
    {
      label: "Dossiers",
      icon: Folder,
      href: "/admin/dossiers",
    },
    {
      label: "Journal d'audit",
      icon: ScrollText,
      href: "/admin/audit",
    },
  ];

  return (
    <aside
      className={cn(
        "fixed top-0 left-0 h-screen z-40 transition-all duration-300",
        isOpen ? "w-64" : "w-0"
      )}
    >
      <button
        type="button"
        onClick={onToggle}
        aria-label={isOpen ? "Fermer le menu" : "Ouvrir le menu"}
        title={isOpen ? "Fermer le menu" : "Ouvrir le menu"}
        className={cn(
          "absolute top-6 right-0 translate-x-1/2 z-50",
          "flex items-center justify-center w-7 h-7 rounded-full",
          "bg-white border border-slate-200 shadow-sm",
          "text-slate-600 hover:text-carex-600 hover:bg-slate-50",
          "transition-colors"
        )}
      >
        {isOpen ? <PanelLeftClose size={16} /> : <PanelLeftOpen size={16} />}
      </button>

      <div className="h-full bg-white border-r border-slate-200 overflow-hidden">
        <div className="py-6 px-6">
          <div className="flex items-center justify-between mb-8">
            {/* Logotype officiel de la charte (CAREX vert + carré bronze) */}
            <NavLink to="/" aria-label="CAREX — accueil">
              <img src={logoCarex} alt="CAREX" className="h-8 w-auto" />
            </NavLink>
          </div>

          <nav className="space-y-2">
            {navItems.map((item) => {
              const Icon = item.icon;
              return (
                <NavLink
                  key={item.href}
                  to={item.href}
                  className={({ isActive }) =>
                    cn(
                      "flex items-center gap-3 px-4 py-3 rounded-lg text-sm font-medium transition-colors duration-200",
                      isActive
                        ? "bg-carex-50 text-carex-600"
                        : "text-slate-700 hover:bg-slate-50"
                    )
                  }
                >
                  <Icon size={20} />
                  <span>{item.label}</span>
                </NavLink>
              );
            })}
          </nav>

          {/* Administration (admin only) */}
          {user?.role === "admin" && (
            <nav className="mt-6 pt-6 border-t border-slate-200 space-y-2">
              <p className="px-4 text-xs font-semibold text-slate-400 uppercase tracking-wider">
                Administration
              </p>
              {adminItems.map((item) => {
                const Icon = item.icon;
                return (
                  <NavLink
                    key={item.href}
                    to={item.href}
                    className={({ isActive }) =>
                      cn(
                        "flex items-center gap-3 px-4 py-3 rounded-lg text-sm font-medium transition-colors duration-200",
                        isActive
                          ? "bg-carex-50 text-carex-600"
                          : "text-slate-700 hover:bg-slate-50"
                      )
                    }
                  >
                    <Icon size={20} />
                    <span>{item.label}</span>
                  </NavLink>
                );
              })}
            </nav>
          )}
        </div>
      </div>
    </aside>
  );
};

export default Sidebar;
